'use client';

import { c as _c } from "react/compiler-runtime";
import dynamic from 'next/dynamic';
import { useCallback, useEffect, useState } from 'react';
import { useOverlayHistory } from '@/hooks/useOverlayHistory';
import { closeResponsiveDialog, useResponsiveDialogStore } from '@/stores/ResponsiveDialogStore';
const ResponsiveDialog = dynamic(() => import('../../organism/ResponsiveDialog').then(mod => ({
  default: mod.ResponsiveDialog
})), {
  ssr: false
});

/**
 * 데스크톱에서는 모달, 모바일에서는 드로워로 표시\
 * openResponsiveDialog를 이용해서 간결하게 사용 가능
 *
 * @example
 *
 * ```tsx
 * import { openResponsiveDialog } from '@/stores/ResponsiveDialogStore';
 *
 * openResponsiveDialog({
 *   component: HouseholdConsent,
 * });
 * ```
 */
export const ResponsiveDialogContainer = () => {
  const $ = _c(19);
  const {
    currentDialog,
    isOpen
  } = useResponsiveDialogStore();
  const [isMounted, setIsMounted] = useState(false);
  const requestClose = _temp;
  useOverlayHistory(isOpen && !!currentDialog, requestClose);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setIsMounted(true);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[2] !== isOpen) {
    t2 = () => {
      const handleKeyDown = event => {
        if (event.key === "Escape" && isOpen) {
          requestClose();
        }
      };
      if (isOpen) {
        document.addEventListener("keydown", handleKeyDown);
      }
      return () => {
        document.removeEventListener("keydown", handleKeyDown);
      };
    };
    t3 = [isOpen, requestClose];
    $[2] = isOpen;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  if (!isMounted || !currentDialog) {
    return null;
  }
  const Component = currentDialog.component;
  let t4;
  if ($[5] !== Component || $[6] !== currentDialog.props) {
    t4 = <Component {...currentDialog.props} onClose={requestClose} />;
    $[5] = Component;
    $[6] = currentDialog.props;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== currentDialog.className || $[9] !== currentDialog.drawerNoPadding || $[10] !== currentDialog.drawerType || $[11] !== currentDialog.duration || $[12] !== currentDialog.forceModal || $[13] !== currentDialog.hideDrawerHeader || $[14] !== currentDialog.modalHeader || $[15] !== currentDialog.title || $[16] !== isOpen || $[17] !== t4) {
    t5 = <ResponsiveDialog opened={isOpen} onClose={requestClose} title={currentDialog.title} duration={currentDialog.duration} className={currentDialog.className} modalHeader={currentDialog.modalHeader} drawerNoPadding={currentDialog.drawerNoPadding} hideDrawerHeader={currentDialog.hideDrawerHeader} drawerType={currentDialog.drawerType} forceModal={currentDialog.forceModal}>{t4}</ResponsiveDialog>;
    $[8] = currentDialog.className;
    $[9] = currentDialog.drawerNoPadding;
    $[10] = currentDialog.drawerType;
    $[11] = currentDialog.duration;
    $[12] = currentDialog.forceModal;
    $[13] = currentDialog.hideDrawerHeader;
    $[14] = currentDialog.modalHeader;
    $[15] = currentDialog.title;
    $[16] = isOpen;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
};
function _temp() {
  closeResponsiveDialog();
}